import React, { useState, useEffect } from 'react';
import { OptionalState } from '../../utils/ReactHelper';
import Logger from '../../../common/utils/Logger';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { ButtonVariant } from '../../utils/BootstrapHelper';
import { SignUpRequest } from '../../../common/SignUp';
import Linker from '../../library/Linker';
import * as yup from 'yup';
import * as formik from 'formik';
import { ApiPath } from '../../../backend/ApiPath';
import { PagePath } from '../PagePath';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

type Props = {
    linker: Linker;
};

type State = {
    show: boolean;
};

const StateDefault: State = {
    show: false,
};

type SignUpValidation = { [T in keyof SignUpRequest]?: string };

const AuthSignUp = (props: Props) => {

    const [state, setState] = useState(StateDefault);

    const updateState = (updates: Partial<State>) => {
        setState(OptionalState(state, updates));
    };

    useEffect(() => {
        new Promise(async (resolve, reject) => {
            return Promise.resolve();
        });
    }, []);

    const variant: ButtonVariant = ButtonVariant.PrimaryOutline;

    const schema: yup.ObjectSchema<SignUpRequest> = yup.object().shape({
        email: yup.string().email().required(),
        password: yup.string().required(),
        firstName: yup.string().required(),
        lastName: yup.string().required(),
    });

    const { Formik } = formik;

    const doToggleShow = (): void => {
        let newShow: boolean = !state.show;
        updateState({
            show: newShow
        });
    };

    const doSubmit = async (values: SignUpRequest, actions: formik.FormikHelpers<SignUpRequest>): Promise<void> => {
        Logger.Log(values, `values`, `doSubmit`);
        let response = await props.linker.SignUp(values);
        actions.setSubmitting(false);
        if (response.success) {
            location.href = `${location.origin}${PagePath.AuthLogin}`; 
        }
        return Promise.resolve();
    };

    const doValidate = (values: SignUpRequest) => {
        const errors: SignUpValidation = {};

        if (!values.email) {
            errors.email = 'Required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'Invalid email address';
        }

        Logger.Log(errors, `errors`, `doValidate`);
        Logger.Log(values, `values`, `doValidate`);

        return errors;
    };

    return (
        <>
            <Formik
                validationSchema={schema}
                onSubmit={doSubmit}
                initialValues={{
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                }}
                validate={doValidate}
                validateOnChange={false}
            >
                {({ values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formSignUp.firstName">
                            <Form.Control className="rounded-start-5 rounded-end-5" required type="string" placeholder="First Name" value={values.firstName} onChange={handleChange} name='firstName' />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formSignUp.lastName">
                            <Form.Control className="rounded-start-5 rounded-end-5" required type="string" placeholder="Last Name" value={values.lastName} onChange={handleChange} name='lastName' />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formSignUp.email">
                            <Form.Control className="rounded-start-5 rounded-end-5" required type="email" placeholder="Email Address" value={values.email} onChange={handleChange} name='email' />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formSignUp.password">
                            <InputGroup>
                                <Form.Control className="rounded-start-5" required type={state.show && 'text' || 'password'} placeholder="Password" value={values.password} onChange={handleChange} name='password' />
                                <Button variant={variant} onClick={doToggleShow} className="rounded-end-5" >
                                    {state.show && <FaEye></FaEye> || <FaEyeSlash></FaEyeSlash>}
                                </Button>
                            </InputGroup>
                        </Form.Group>
                        <Button type="submit" className="rounded-start-5 rounded-end-5">Submit</Button>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default AuthSignUp;